export default __webpack_public_path__ + "static/media/EP02_ERYTHREE.4ec2efeb.mp3";